import { render } from "./AllCourses.vue?vue&type=template&id=bb45a06a&scoped=true"
import script from "./AllCourses.vue?vue&type=script&lang=js"
export * from "./AllCourses.vue?vue&type=script&lang=js"

import "./AllCourses.vue?vue&type=style&index=0&id=bb45a06a&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb45a06a"]])

export default __exports__